/**
 * Remove unneeded fields from OpenApiResponse.
 * @param {OpenApiResponse} openApiObj
 * @returns {OpenApiResponse}
 */
function trimOpenApiFile(openApiObj) {
  const data = openApiObj

  const result = {
    paths: data.paths
  }

  for (const path in data.paths) {
    const newPath = {}
    for (const method in data.paths[path]) {
      const methodData = data.paths[path][method]
      newPath[method] = { security: methodData.security }
    }
    result.paths[path] = newPath
  }

  return result
}

/**
 * This is using module.exports for interoperability between running
 * with node at the command line and using in our webapp.
 */
module.exports = {
  trimOpenApiFile
}
